import React, { Component } from 'react'
import VideoPlayer from "../Helper/VideoPlayer";
import arrowUp from '../../assets/images/icons/arrow-up.png'
import arrowDown from '../../assets/images/icons/arrow-down.png'


export default class TestDix extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div>
           
         
          <div className="mt-3">
              <div className="row">
                <div className="col-lg-5">
                    <VideoPlayer src="https://www.youtube.com/embed/AZFyz12_gCY" thumbnail='Dix-Hallpike-10.jpg' width="300"/>
                </div>
                <div className="col-lg-6">
                  <h2>Now we’re going to perform a maneuver called the Dix-Hallpike Test.</h2>
                  <p>
                    Watch the video and perform the test as shown. 
                  </p>
                  <p>
                  Observe the eyes for involuntary movements during the test. The video will show some examples of what to look for.
                  </p>
                  <p>Then, select the option that best describes what you saw.</p>
                </div>
               
              </div>
              
              <div className="row mt-5">
                <div className="col-lg-4">
                  <button className="btn btn-dark w-100 p-2H text-left"  onClick={onClick.bind(this,20,true)}>
                  <div className="float-left">Upbeat Torsional</div>
                  <img alt="arrowup" className="float-right" src={arrowUp} width="25"/>
                  </button>
                </div>
                
                <div className="col-lg-4">
                  <button className="btn btn-secondary w-100 p-2H text-left"  onClick={onClick.bind(this,17,true)}>
                  <div className="float-left">Downbeating</div>
                   <img alt="arrow-down" className="float-right" src={arrowDown} width="20"/>
                  </button>
                  
                </div>
                
                <div className="col-lg-4">
                  <button className="btn btn-info w-100 p-2H text-left"  onClick={onClick.bind(this,11,false)}>
                  <div className="float-left">None of these</div>
                    <i className="fa fa-ban float-right t-30"></i>
                    </button>
                </div>
              </div>
          </div>
         
        </div>

    )
  }
}
